import React, { useState } from 'react'
import { bool, shape, string, func, arrayOf, number } from 'prop-types'
import { TreeProvider } from './state/TreeStore'
import AncestryTree from './AncestryTree'
import AncestryTreeAam from './AncestryTreeAam'
import AncestorEditor from './AncestorEditor'

export default function TreeMain({ overlay, aamState, aamDispatch }) {
  const [isTreeShowing, setIsTreeShowing] = useState(true)
  return (
    <TreeProvider>
      {isTreeShowing && aamDispatch && (
        <AncestryTreeAam
          setIsTreeShowing={setIsTreeShowing}
          overlay={overlay}
          aamState={aamState}
          aamDispatch={aamDispatch}
        />
      )}
      {isTreeShowing && !aamDispatch && <AncestryTree setIsTreeShowing={setIsTreeShowing} overlay={overlay} />}
      {!isTreeShowing && <AncestorEditor setIsTreeShowing={setIsTreeShowing} aamDispatch={aamDispatch} />}
    </TreeProvider>
  )
}

TreeMain.propTypes = {
  overlay: shape({
    isOpen: bool.isRequired,
    open: func.isRequired,
    close: func.isRequired,
  }).isRequired,
  aamState: shape({
    atfGuestOptionSelected: bool,
    countryCode: string,
    firstName: string,
    fullName: string,
    guestTree: arrayOf(shape({})),
    initialTileDataRequested: bool,
    isAddTreeFlowShowing: bool,
    isGuestUser: bool,
    isLoading: bool,
    lastName: string,
    options: shape,
    tileData: arrayOf(shape({})),
    tree: arrayOf(shape({})),
    year: number,
  }),
  aamDispatch: func,
}
